import { render, staticRenderFns } from "./customerPriceListUpdateDialog.vue?vue&type=template&id=4196c9ff&"
import script from "./customerPriceListUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./customerPriceListUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports